import React from "react";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import { useTranslation } from "next-i18next";
import { selectStyles } from "@/utils/selectStyles";

const animatedComponents = makeAnimated();

const SelectCreatable = React.forwardRef(
  (
    {
      readOnly = false,
      lg = false,
      isInvalid = false,
      tags = false,
      sm = false,
      rounded = true,
      ...rest
    }: {
      readOnly?: boolean;
      lg?: boolean;
      isInvalid?: boolean;
      tags?: boolean;
      sm?: boolean;
      rounded?: boolean;
      [x: string]: unknown;
    },
    ref
  ): React.ReactElement => {
    const { t } = useTranslation("common");

    return (
      <CreatableSelect
        styles={selectStyles(lg, isInvalid, tags, sm, rounded)}
        placeholder={t("chooseOrType")}
        isSearchable={!readOnly}
        menuIsOpen={readOnly ? false : undefined}
        formatCreateLabel={(value) => (
          <>
            {t("create")} &quot;{value}&quot;
          </>
        )}
        noOptionsMessage={() => t("noOptions")}
        components={animatedComponents}
        ref={ref}
        {...rest}
      />
    );
  }
);

SelectCreatable.displayName = "SelectCreatable";

export default SelectCreatable;
